import JourneyMetricsRoute from 'cio/pods/base/overview/journey_metrics/route';

export default class CampaignJourneyMetricsRoute extends JourneyMetricsRoute {}
